import React from 'react'
import { Row, Col, Input, Select } from 'antd'
import ColorInput from '../../components/ColorInput'
import './style.less'
import { Form } from '../../../../interface'

interface Props extends Form<{
  text: string,
  size: number,
  color: string
}> {
  sizeRange?: number[]
}

/**
 * Text
 * Size
 * CoLor
 * 
 * Editor
 */
interface TSCEditorFormComponent extends React.FC<Props> {
  Header: React.FC
}

const clsPrefix = 'c-tsc-edt';

const TSCEditorForm: TSCEditorFormComponent = ({
  value,
  onChange,
  sizeRange = [12, 14, 16, 18, 20, 22, 24]
}) => (
  <Row className={clsPrefix}>
    <Col span={6}>
      <Input
        value={value.text}
        style={{ width: '166px' }}
        onChange={e => {
          onChange({
            ...value,
            text: e.target.value
          })
        }}
      />
    </Col>
    <Col span={2}>
      <Select
        size="large"
        value={value.size}
        onChange={(_value: number) => {
          onChange({
            ...value,
            size: _value,
          })
        }}
      >
        {sizeRange.map(item => (
          <Select.Option value={item}>{item}</Select.Option>
        ))}
      </Select>
    </Col>
    <Col span={2}>
      <ColorInput
        style={{ width: '40px', padding: '4px' }}
        onChange={color => {
          onChange({
            ...value,
            color,
          })
        }}
        value={value.color}
      />
    </Col>
  </Row>
)

const Header: React.FC = () => (
  <Row>
    <Col span={7}>文案:</Col>
    <Col span={3}>大小:</Col>
    <Col span={2}>颜色:</Col>
  </Row>
)

export {
  Header
}

TSCEditorForm.Header = Header

export default TSCEditorForm;